import { useState } from 'react'

import { Input } from 'antd'
import styled from 'styled-components'

import { Button } from '../shared-components/BUI/Button'

const Wrapper = styled.div`
  padding: 0.5rem;
  margin-top: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colour.secondary._50};
`

const NoteActions = styled.div`
  margin-top: 0.5rem;
  display: flex;
  gap: 0.5rem;
`

type NotesEditorProps = {
  value?: string
  onChange?: (value: string) => void
  editing: boolean
  stopEditing: () => void
}

export const NotesInput: React.FC<NotesEditorProps> = ({
  value,
  onChange,
  editing,
  stopEditing,
}) => {
  const [draftNotes, setDraftNotes] = useState(value)

  const handleSave = () => {
    onChange(draftNotes)
    stopEditing()
  }

  if (!editing) return null

  return (
    <Wrapper>
      <Input.TextArea
        rows={3}
        placeholder="Note"
        autoFocus
        value={draftNotes}
        onChange={(e) => setDraftNotes(e.target.value)}
      />
      <NoteActions>
        <Button size="small" onClick={handleSave} variant="primary">
          Save
        </Button>
        <Button size="small" onClick={stopEditing}>
          Cancel
        </Button>
      </NoteActions>
    </Wrapper>
  )
}
